import { useContext, useEffect } from "react";

import { MktgDataContext } from "@swa-ui/application";
import { useLocation, useScreenSize } from "@swa-ui/browser";
import { PlacementsContext, usePlacement } from "@swa-ui/placements";

export function useBookingSectionAnalytics() {
  const { contentItems: pageLayout } = usePlacement?.("pageLayout")?.placement?.placement ?? {};
  const { pathname } = useLocation();
  const { placement: bookingSectionPlacement = {} } =
    usePlacement?.("bookingSection")?.placement ?? {};
  const { placements } = useContext(PlacementsContext);
  const { screenSize } = useScreenSize();
  const { setMktgPageData } = useContext(MktgDataContext);

  useEffect(() => {
    if ((pathname === "/" || pathname.includes("/landing/home-page/")) && pageLayout) {
      setMktgPageData(
        {
          moduleposition: getModulePosition(),
          widget_position: getBookingWidgetPosition(),
        },
        "landingHomePage"
      );
    }
  }, [pathname, placements]);

  function getBookingWidgetPosition() {
    const { items = [] } = bookingSectionPlacement;
    const placementId = items[0]?.id;
    let bookingWidgetPosition = placementId === "bookingWidget" ? "left" : "right";

    if (screenSize === "small") {
      bookingWidgetPosition = placementId === "bookingWidget" ? "top" : "bottom";
    }

    return bookingWidgetPosition;
  }

  function getChildPlacementIds(placementId) {
    const { contentBlockId } = placements[placementId]?.content?.placementData ?? {};
    let childContentBlockIds = [];
    let childPlacementId = placements[placementId]?.content?.placement?.id;

    while (childPlacementId) {
      if (placements[`${childPlacementId}1`]) {
        childContentBlockIds = Object.keys(placements)
          .filter((placementKey) => placementKey.includes(childPlacementId))
          .map((placementKey) => placements[placementKey].content?.placementData?.contentBlockId);
      }

      childPlacementId = placements[childPlacementId]?.content?.placement?.id;
    }

    return [contentBlockId, ...childContentBlockIds].filter(Boolean);
  }

  function getModulePosition() {
    const placementPositionList = [];
    let currentPosition = 1;

    pageLayout?.forEach((contentItem) => {
      let contentId;

      if (contentItem.type === "placement") {
        const childContentBlockIds = getChildPlacementIds(contentItem.id);

        contentId = childContentBlockIds.join(";");
      } else if (contentItem.type === "component") {
        contentId = contentItem.id;
      }

      if (contentId) {
        placementPositionList.push(`p${currentPosition};${contentId}`);
        currentPosition += 1;
      }
    });

    return placementPositionList.join(":");
  }
}
